export * from './IndustryIcon';
